import { render } from "./getDriverbyId.vue?vue&type=template&id=01444cba&scoped=true"
import script from "./getDriverbyId.vue?vue&type=script&lang=js"
export * from "./getDriverbyId.vue?vue&type=script&lang=js"

import "./getDriverbyId.vue?vue&type=style&index=0&id=01444cba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01444cba"]])

export default __exports__